import React from "react";

const Pill = ({ signed, children }) => (
  <span className={`status-pill ${signed ? "status-signed" : "status-pending"}`}>{children}</span>
);

/**
 * Adult: one pill ("Athlete: Signed"). Minor: athlete/caddie pill + "Parent: …" pill.
 * Uses per-signer Legalesign statuses when stored; otherwise falls back to the overall document status.
 */
const DocumentStatusPills = ({ status, signers, isMinor = false, role = "Athlete" }) => {
  const docStatus = String(status || "").toUpperCase() === "SIGNED" ? "SIGNED" : "NOT_SIGNED";
  const list = Array.isArray(signers) && signers.length
    ? [...signers]
    : [{ order: 0, role, status: docStatus }];
  if (isMinor && !list.some((s) => s.role === "Parent")) {
    list.push({ order: list.length, role: "Parent", status: docStatus });
  }

  return (
    <div className="d-flex flex-column align-items-start gap-1">
      {list.map((s) => {
        const signed = s.status === "SIGNED";
        return (
          <Pill key={s.order} signed={signed}>
            {s.role}: {signed ? "Signed" : "Not signed"}
          </Pill>
        );
      })}
    </div>
  );
};

export default DocumentStatusPills;
